import { Card } from "react-bootstrap"
import { Link, useRouteMatch } from "react-router-dom"
import moment from 'moment'

function ProvCardNoTodayCita({item}) {
    const {patientDTO, scheduleDTO} = item
    const {url} = useRouteMatch()

    return(
        <Card className="shadow-1 ">
            <Card.Body>
                <h6>{`${patientDTO?.name} ${patientDTO?.middleName ?? ''} ${patientDTO?.lastName} ${patientDTO?.seccondSurname ?? ''}`}</h6>

                <small className="d-block color-7F8FA4">Cita</small>
                <label><strong>{item.speciality.name}</strong> - Seguimiento</label>

                <div className="d-flex justify-content-between">
                    <div>
                        <small className="d-block color-7F8FA4">Día</small>
                        <small className="d-block">{moment(scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD MMMM YYYY")}</small>
                    </div>
                    <div>
                        <small className="d-block color-7F8FA4">Hora</small>
                        <small className="d-block">{moment(scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("HH:mm")}</small>
                    </div>
                </div>

                <hr />

                <div className="d-flex justify-content-between">
                    <div>
                        {/* <small className="d-block color-red">Cambiar cita</small> */}
                    </div>
                    <div>
                        <Link to={`${url}/proveedor/conferencia/${btoa(item.id)}`} className="no-underline"><small className="d-block color-green">Ver consulta</small></Link>
                    </div>
                </div>
            </Card.Body>
        </Card>
    )
}

export default ProvCardNoTodayCita